import { fillArr, getByOrder } from '@hglobal/fin-ui';

import { Transaction } from '@kr/models';
import { getCoinsMock, transactionStatusCodes, transactionTypesCodes } from '@kr/store';

export function getTransactionsMock(count = 12, statusOriginal?: Transaction['statusOriginal']): Transaction[] {
  const coins = getCoinsMock();

  const riskScoreArr = [
    {
      riskScore: '0.01%',
      riskScorePassed: true,
      riskScoreError: '',
    },
    {
      riskScore: '0.49%',
      riskScorePassed: true,
      riskScoreError: '',
    },
    {
      riskScore: '0.6%',
      riskScorePassed: false,
      riskScoreError: '',
    },
    {
      riskScore: null,
      riskScorePassed: true,
      riskScoreError: 'Wallet inactive on the blockchain, unable to screen',
    },
    {
      riskScore: null,
      riskScorePassed: false,
      riskScoreError: 'Technical error',
    },
  ];

  return fillArr(count, i => {
    const randomRiskScore = riskScoreArr[Math.floor(Math.random() * riskScoreArr.length)];
    return {
      id: i,
      address: `0x8Fa71B52BF9A1eD1779f3f94f8c712B406E${i}`,
      addressOut: `0x2BFf94f8c712Ba8F71B54069A1eD1779f3E9A${i}`,
      fromWallet: `0x8Fa71B52BF9A1eD1779f3f94f8c712B406E${i}`,
      toWallet: `0x2BFf94f8c712Ba8F71B54069A1eD1779f3E9A${i}`,
      tx: `0x9A1eD1775406f3E9AFf9492BF71Bf8c712Ba8${i}`,
      trTypeString: getByOrder(i, transactionTypesCodes),
      created: new Date().getTime(),
      amount: String(i * 100),
      totalAmount: String(i * 100 + i * 3),
      feeTotal: String(i * 3),
      feeTotalCoinId: getByOrder(i + 2, coins).id,
      feeTotalNative: String(i * 9),
      network_fee_amount: String(i * 2),
      process_fee_amount: String(i * 7),
      comment: i % 2 ? null : `Comment ${i}`,
      coinId: getByOrder(i, coins).id,
      network_fee_coin_id: getByOrder(i + 2, coins).id,
      coin: getByOrder(i, coins),
      networkFeeCoin: getByOrder(i + 2, coins),
      statusOriginal: statusOriginal ?? getByOrder(i, transactionStatusCodes),
      fromWalletType: Math.random() < 0.5 ? 'ALT' : 'BASE',
      riskScore: randomRiskScore.riskScore,
      riskScorePassed: randomRiskScore.riskScorePassed,
      riskScoreError: randomRiskScore.riskScoreError,
      internalOrgId: i,
      ourEstimatedFee: null,
      warnings: "Can't get a status from provider",
    };
  });
}
